module.exports = __webpack_public_path__ + "media/img/pages/profile/kpmg ger 8-a135e69bee990084d7a8a657e3b75a54.jpg";